import {AnswerType, EMAIL_REGEX, ERROR_CLASS, FILL_CLASS, PHONE_MIN_LENGTH} from "./utils/consts";
import {changeCount} from "./cart/changeCount/changeCount";
import {fadeIn, fadeOut, formatedPrice} from "./utils/common";
import {Api} from "./api/api";

const TabType = {
  PICKUP: `pickup-amrita`,
  COURIER: `office-home`,
};

const TabClassName = {
  [`pickup-amrita`]: `fast-order__delivery--pickup`,
  [`office-home`]: `fast-order__delivery--courier`,
};

const changeTabsClasses = [`fast-order__delivery--pickup`, `fast-order__delivery--courier`];

const DELIVERY_NAME = `OrderInOneClick[type_delivery]`;

export class FastOrder {
  #form;
  #answer;
  #api = new Api();
  #pickupElement;
  #courierElement;
  #phoneInputElement;
  #nameInputElement;
  #emailInputElement;

  #currentDeliveryValue;
  #tabsContainerElement;
  #currentDeliveryClass;
  #submitButton;
  #addressInputElement;
  #textFieldsElements;
  #changeCount;
  #priceElement;
  #productPrice;
  #failAnswerElement;
  #successAnswerElement;

  constructor(formElement) {
    this.#form = formElement;
    this.#answer = this.#form.querySelector(`.js-fast-order-answer`);

    this.#successAnswerElement = this.#answer.querySelector(`.js-success`);
    this.#failAnswerElement = this.#answer.querySelector(`.js-fail`);

    this.#pickupElement = this.#form.querySelector(`.js-fast-order-pickup`);
    this.#courierElement = this.#form.querySelector(`.js-fast-order-courier`);

    this.#tabsContainerElement = this.#form.querySelector(`.js-fast-order-tabs`);

    this.#textFieldsElements = this.#form.querySelectorAll(`[data-validation-type]`);

    this.#phoneInputElement = this.#form.querySelector(`[data-validation-type="phone"]`);
    this.#nameInputElement = this.#form.querySelector(`[data-validation-type="name"]`);
    this.#emailInputElement = this.#form.querySelector(`[data-validation-type="email"]`);
    this.#addressInputElement = this.#form.querySelector(`[data-validation-type="address"]`);

    this.#submitButton = this.#form.querySelector(`.js-fast-order-submit`);

    this.#priceElement = this.#form.querySelector(`.js-fast-order-price`);

    this.#currentDeliveryValue = this.#form[DELIVERY_NAME].value;
    this.#currentDeliveryClass = this.#getCurrentDeliveryClass();

    this.#changeCount = changeCount;
    this.#productPrice = +this.#priceElement.dataset.price;

    this.onFormChange = this.onFormChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onSubmitButtonMouseenter = this.onSubmitButtonMouseenter.bind(this);
    this.onTextFieldInput = this.onTextFieldInput.bind(this);
    this.changePrice = this.changePrice.bind(this);
  }

  getCurrentDeliveryValue() {
    return this.#currentDeliveryValue;
  }

  init() {
    this.#changeCount(this.#form, this.changePrice, true);

    this.#form.addEventListener(`change`, this.onFormChange);
    this.#form.addEventListener(`submit`, this.onFormSubmit);
    this.#submitButton.addEventListener(`mouseenter`, this.onSubmitButtonMouseenter);
    this.#textFieldsElements.forEach((textField) => {
      textField.addEventListener(`input`, this.onTextFieldInput);
    });
  }

  #validateElement = {
    name: (element) => element.value.length,
    address: (element) => element.value.length,
    phone: (element) => element.value.length >= PHONE_MIN_LENGTH,
    email: (element) => element.value.match(EMAIL_REGEX),
  };

  #showTab(type) {
    this.#tabsContainerElement.classList.remove(this.#currentDeliveryClass);
    this.#tabsContainerElement.classList.add(TabClassName[type]);
  }

  #setCurrentDeliveryValue(value) {
    this.#currentDeliveryValue = value;
  }

  #setCurrentDeliveryClass(value) {
    this.#currentDeliveryClass = TabClassName[value];
  }

  #getCurrentDeliveryClass() {
    let currentClass;
    changeTabsClasses.forEach((tabClass) => {
      if (this.#tabsContainerElement.classList.contains(tabClass)) {
        currentClass = tabClass;
      }
    });

    return currentClass;
  }

  #getNameValidationStatus() {
    return this.#nameInputElement.classList.contains(FILL_CLASS);
  }

  #getPhoneValidationStatus() {
    return this.#phoneInputElement.classList.contains(FILL_CLASS);
  }

  #getEmailValidationStatus() {
    return this.#emailInputElement.classList.contains(FILL_CLASS);
  }

  #getAddressValidationStatus() {
    return this.#addressInputElement.classList.contains(FILL_CLASS);
  }

  #validateTextFieldInput(element, type, isSubmitHover) {
    if (this.#validateElement[type](element)) {
      element.classList.remove(ERROR_CLASS);
      element.classList.add(FILL_CLASS);
    } else {
      element.classList.remove(FILL_CLASS);

      if (isSubmitHover) {
        element.classList.add(ERROR_CLASS);
      }
    }
  }

  #removeAddressInputValidationClasses() {
    this.#addressInputElement.classList.remove(ERROR_CLASS);
    this.#addressInputElement.classList.remove(FILL_CLASS);
  }

  #showAnswer(type) {
    fadeIn(this.#answer, 200, `flex`);
    switch (type) {
      case AnswerType.SUCCESS:
        fadeIn(this.#successAnswerElement, 200, `block`);
        break;
      case AnswerType.FAIL:
        fadeIn(this.#failAnswerElement, 200, `block`);
        break;
    }
  }

  #hideAnswer(type) {
    fadeOut(this.#answer, 200);
    switch (type) {
      case AnswerType.SUCCESS:
        fadeOut(this.#successAnswerElement, 200);
        break;
      case AnswerType.FAIL:
        fadeOut(this.#failAnswerElement, 200);
        break;
    }
  }

  #resetForm() {
    this.#form.reset();
  }

  #changeDeliveryType() {
    if (this.getCurrentDeliveryValue() !== this.#form[DELIVERY_NAME].value) {
      this.#showTab(this.#form[DELIVERY_NAME].value);
      this.#setCurrentDeliveryValue(this.#form[DELIVERY_NAME].value);
      this.#setCurrentDeliveryClass(this.#form[DELIVERY_NAME].value);

      if (this.getCurrentDeliveryValue() !== TabType.COURIER) {
        this.#removeAddressInputValidationClasses();
      }
    }
  }

  changePrice(count) {
    this.#priceElement.textContent = `${formatedPrice(this.#productPrice * count)} ₽`;
  }

  onTextFieldInput(evt) {
    const self = evt.currentTarget;
    const type = self.dataset.validationType;

    this.#validateTextFieldInput(self, type);
  }

  onSubmitButtonMouseenter() {
    this.#textFieldsElements.forEach((textFieldElement) => {
      const type = textFieldElement.dataset.validationType;

      if (type !== `address`) {
        this.#validateTextFieldInput(textFieldElement, type, true);
      } else {
        if (this.getCurrentDeliveryValue() === TabType.COURIER) {
          this.#validateTextFieldInput(textFieldElement, type, true);
        }
      }
    });
  }

  async onFormSubmit(evt) {
    if (
      !this.#getNameValidationStatus() ||
      !this.#getPhoneValidationStatus() ||
      !this.#getEmailValidationStatus() ||
      (this.getCurrentDeliveryValue() === TabType.COURIER && !this.#getAddressValidationStatus())
    ) {
      evt.preventDefault();
    } else {
      evt.preventDefault();
      const formData = new FormData(this.#form);
      this.#api.sendFastOrder(formData).then((data) => {
        if (data === 200) {
          this.#showAnswer(AnswerType.SUCCESS);
          this.#resetForm();
          this.#changeDeliveryType();
          setTimeout(() => {
            this.#hideAnswer(AnswerType.SUCCESS);
          }, 4000);
        } else {
          this.#showAnswer(AnswerType.FAIL);
          setTimeout(() => {
            this.#hideAnswer(AnswerType.FAIL);
          }, 4000);
        }
      });
    }
  }

  onFormChange() {
    this.#changeDeliveryType();
  }
}
